import { createBrowserRouter, useRouteError, useNavigate } from 'react-router-dom'
import AppLayout from './components/layout/AppLayout'
import ConnectPage from './pages/ConnectPage'
import HomePage from './pages/HomePage'
import ModelsPage from './pages/ModelsPage'
import ChatListPage from './pages/ChatListPage'
import ChatSessionPage from './pages/ChatSessionPage'
import DepositPage from './pages/DepositPage'
import ComparePage from './pages/ComparePage'

/** Route-level error boundary — replaces React Router default "Hey developer" screen */
function RouteErrorBoundary() {
  const error = useRouteError() as Error | { status?: number; statusText?: string }
  const navigate = useNavigate()

  const is404 = 'status' in error && error.status === 404
  const message = is404
    ? 'Page not found'
    : error instanceof Error
      ? error.message
      : 'Something went wrong'

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen px-sp-4 text-center"
      style={{ backgroundColor: 'var(--tg-theme-bg-color, #fff)' }}
    >
      <div
        className="text-[48px] mb-sp-4"
        style={{ color: 'var(--tg-theme-hint-color, #999)' }}
      >
        {is404 ? '🔍' : '⚠️'}
      </div>
      <h1
        className="text-[20px] font-semibold mb-sp-2"
        style={{ color: 'var(--tg-theme-text-color, #000)' }}
      >
        {is404 ? 'Page not found' : 'Oops!'}
      </h1>
      <p
        className="text-[14px] mb-sp-6 max-w-[280px]"
        style={{ color: 'var(--tg-theme-hint-color, #999)' }}
      >
        {message}
      </p>
      <div className="flex gap-sp-2">
        <button
          onClick={() => navigate('/')}
          className="h-11 px-sp-6 rounded-[14px] text-[15px] font-semibold active:opacity-70 transition-opacity"
          style={{
            backgroundColor: 'var(--tg-theme-button-color, #007aff)',
            color: 'var(--tg-theme-button-text-color, #fff)',
          }}
        >
          Go Home
        </button>
        {!is404 && (
          <button
            onClick={() => window.location.reload()}
            className="h-11 px-sp-6 rounded-[14px] text-[15px] font-medium active:opacity-70 transition-opacity"
            style={{
              backgroundColor: 'var(--tg-theme-secondary-bg-color, #f2f2f7)',
              color: 'var(--tg-theme-text-color, #000)',
            }}
          >
            Retry
          </button>
        )}
      </div>
    </div>
  )
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'models', element: <ModelsPage /> },
      { path: 'compare', element: <ComparePage /> },
      { path: 'chat', element: <ChatListPage /> },
      { path: 'chat/:id', element: <ChatSessionPage /> },
      { path: 'deposit', element: <DepositPage /> },
    ],
  },
  {
    path: '/connect',
    element: <ConnectPage />,
    errorElement: <RouteErrorBoundary />,
  },
])
